import React from 'react';
import dynamic from 'next/dynamic';
import { createGlobalStyle } from 'styled-components';
import { TechnicalHead } from '@layouts/Technical-Head';
import { Colors } from 'planoplan-ui-kit/core/colors';

const Cookies = dynamic(() => import('../components/Cookies').then((mod) => mod.Cookies), { ssr: false });

export const TechnicalLayout = ({ title, children, isHidePage = false, meta = null, isShowCookiesPopup = false }) => (
  <>
    <GlobalStyle />
    <TechnicalHead title={title} isHidePage={isHidePage} meta={meta} />
    {children}
    {isShowCookiesPopup && <Cookies />}
  </>
);

const GlobalStyle = createGlobalStyle`
  :root {
   scrollbar-gutter: auto;
  }

  body {
    min-width: 320px;
    background-color: ${Colors.white};
  }
`;
